import type { ApiResponse } from "api/ApiResponses";
import type { AppState } from "ee/reducers";
import type { ReduxAction } from "ee/constants/ReduxActionConstants";
import {
  ReduxActionErrorTypes,
  ReduxActionTypes,
} from "ee/constants/ReduxActionConstants";
import { all, call, delay, put, select, take } from "redux-saga/effects";
import { validateResponse } from "sagas/ErrorSagas";
import DraftApi, { type SavePageDraftRequest } from "api/DraftApi";
import { isEmpty } from "lodash";

export function* getPageDraftSaga(action: ReduxAction<{ pageId: string }>) {
  try {
    const pageId: string = action.payload.pageId;
    const response: ApiResponse = yield call(DraftApi.getPageDraft, pageId);
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      console.log("getPageDraftSaga===>", response);
      yield put({
        type: ReduxActionTypes.GET_PAGE_DRAFT_SUCCESS,
        payload: {
          pageId,
          data: response.data,
        },
      });
      return isEmpty(response?.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* savePageDraftSaga(action: ReduxAction<SavePageDraftRequest>) {
  try {
    const request: SavePageDraftRequest = action.payload;
    const response: ApiResponse = yield call(DraftApi.savePageDraft, request);
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      yield put({
        type: ReduxActionTypes.SAVE_DRAFT_SUCCESS,
        payload: {
          pageId: request.pageId,
          // isSuccess: true,
        },
      });
    }
  } catch (error) {
    console.log(error);
  }
}

export function* restorePageDraftSaga(action: ReduxAction<{ pageId: string }>) {
  try {
    const pageId: string = action.payload.pageId;
    const response: ApiResponse = yield call(DraftApi.restorePageDraft, pageId);
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      yield put({
        type: ReduxActionTypes.RESTORE_DRAFT_SUCCESS,
        payload: {
          pageId,
        },
      });
    }
  } catch (error) {
    console.log(error);
  }
}

export function* deletePageDraftSaga(action: ReduxAction<{ pageId: string }>) {
  try {
    const pageId: string = action.payload.pageId;
    const response: ApiResponse = yield call(DraftApi.deletePageDraft, pageId);
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      yield put({
        type: ReduxActionTypes.DELETE_DRAFT_SUCCESS,
        payload: {
          pageId,
        },
      });
    }
  } catch (error) {
    console.log(error);
  }
}
